/* Atipiná PDP — Klaviyo Back in Stock + Recomendações v8
   v7: identidade compartilhada (esconde email conhecido + "não é você?").
   v8 (2026-06-02): recomendações filtram por TAMANHO procurado (produtos com a
   variante daquele tamanho disponível), cap 4. Re-filtra quando o modal abre ou
   o tamanho muda. Fallback: similares genéricos se nenhum naquele tamanho.
   Compartilha só o e-mail (não o nome). */
(function(){
  'use strict';

  var SPECIFIC_TAGS = ['camiseta-over','camiseta-manga-longa','calca-leve','calca-moletom','calca-tactel','moletom-meio-ziper','moletom-over','bermuda-leve','bermuda-sarja','bermuda-jeans','corta-vento','jardineira','vestido','regata','bucket','meia','shorts'];
  var GENERAL_TAGS = ['camiseta','calca','moletom','bermuda','jeans'];
  var CATEGORY_TAGS = ['partes-de-cima','partes-de-baixo','inteirinhos','jaquetas-moletons','acessorios'];
  var EXCLUDED_HANDLES = ['cartao-de-presente'];
  var INSTALLMENTS = 4;
  var MAX_RESULTS = 4;

  var allProductsPromise = null;
  function getAllProducts(){
    if (allProductsPromise) return allProductsPromise;
    allProductsPromise = fetch('/products.json?limit=250')
      .then(function(r){ return r.json(); })
      .then(function(data){ return data.products || []; });
    return allProductsPromise;
  }

  function toNumber(value){
    var num;
    if (typeof value === 'number') num = value > 1000 ? value / 100 : value;
    else if (typeof value === 'string') num = parseFloat(value.replace(',', '.'));
    else num = 0;
    if (isNaN(num)) num = 0;
    return num;
  }
  function formatMoney(value){ return 'R$ ' + toNumber(value).toFixed(2).replace('.', ','); }

  function getImageUrl(p){
    if (p.featured_image) return p.featured_image;
    if (p.images && p.images.length && p.images[0]) return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src;
    if (p.media && p.media[0] && p.media[0].preview_image) return p.media[0].preview_image.src;
    return '';
  }
  function parseTags(t){
    if (!t) return [];
    if (Array.isArray(t)) return t.map(function(x){ return String(x).trim().toLowerCase(); });
    return String(t).split(',').map(function(x){ return x.trim().toLowerCase(); }).filter(Boolean);
  }
  function isProductAvailable(p){
    if (!p.variants || !p.variants.length) return true;
    return p.variants.some(function(v){ return v.available; });
  }

  /* Índice (1-based) da opção de tamanho do produto (fallback: 1ª opção) */
  function getSizeOptionIndex(p){
    var opts = p.options;
    if (opts && opts.length){
      for (var i = 0; i < opts.length; i++){
        var nm = (typeof opts[i] === 'string' ? opts[i] : (opts[i].name || '')).toString().toLowerCase();
        if (nm.indexOf('tamanho') > -1 || nm.indexOf('size') > -1 || nm.indexOf('talla') > -1) return i + 1;
      }
    }
    return 1;
  }
  /* produto tem a variante do tamanho-alvo DISPONÍVEL? */
  function productHasSizeAvailable(p, size){
    if (!size) return false;
    var idx = getSizeOptionIndex(p);
    var target = String(size).trim().toLowerCase();
    return (p.variants || []).some(function(v){
      if (!v.available) return false;
      var val = v['option' + idx];
      return val != null && String(val).trim().toLowerCase() === target;
    });
  }

  function formatBrPhone(raw){
    var d = String(raw || '').replace(/\D/g, '').slice(0, 11);
    if (d.length === 0) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 6) return '(' + d.slice(0,2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0,2) + ') ' + d.slice(2,6) + '-' + d.slice(6);
    return '(' + d.slice(0,2) + ') ' + d.slice(2,7) + '-' + d.slice(7);
  }
  function bindPhoneMask(input){
    if (!input || input._brMaskBound) return;
    input._brMaskBound = true;
    input.addEventListener('input', function(){ input.value = formatBrPhone(input.value); });
    input.addEventListener('blur', function(){ input.value = formatBrPhone(input.value); });
  }

  function renderProductCard(p){
    var img = getImageUrl(p);
    var compareRaw = p.compare_at_price || p.compare_at_price_min || (p.variants && p.variants[0] && p.variants[0].compare_at_price) || 0;
    var priceRaw = p.price || p.price_min || (p.variants && p.variants[0] && p.variants[0].price) || 0;
    var priceNum = toNumber(priceRaw);
    var compareNum = toNumber(compareRaw);
    var hasCompare = compareNum > priceNum && priceNum > 0;
    var installment = priceNum > 0 ? priceNum / INSTALLMENTS : 0;
    var title = (p.title || '').replace(/"/g,'&quot;');
    var url = '/products/' + (p.handle || '');
    return ''
      + '<a href="' + url + '" class="pdp-live__soldout-card">'
      +   '<div class="pdp-live__soldout-card-image">'
      +     (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy">' : '')
      +   '</div>'
      +   '<div class="pdp-live__soldout-card-title">' + title + '</div>'
      +   '<div class="pdp-live__soldout-card-price">'
      +     (hasCompare ? '<s>' + formatMoney(compareNum) + '</s>' : '')
      +     '<strong>' + formatMoney(priceNum) + '</strong>'
      +     (installment > 0 ? '<span class="pdp-live__soldout-card-installments">' + INSTALLMENTS + 'x ' + formatMoney(installment) + ' sem juros</span>' : '')
      +   '</div>'
      + '</a>';
  }

  function scoreProduct(productTags, currentTags){
    var score = 0;
    productTags.forEach(function(t){
      if (currentTags.indexOf(t) >= 0) {
        if (SPECIFIC_TAGS.indexOf(t) >= 0) score += 5;
        else if (GENERAL_TAGS.indexOf(t) >= 0) score += 2;
        else if (CATEGORY_TAGS.indexOf(t) >= 0) score += 1;
      }
    });
    return score;
  }

  function renderSlider(container, products){
    container.innerHTML = '';
    container.classList.add('pdp-live__soldout-products--slider');

    var track = document.createElement('div');
    track.className = 'pdp-live__soldout-track';
    track.innerHTML = products.map(renderProductCard).join('');
    container.appendChild(track);

    if (products.length <= 4) return;

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'pdp-live__soldout-arrow pdp-live__soldout-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Anterior');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22"><path d="M15 18l-6-6 6-6"/></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'pdp-live__soldout-arrow pdp-live__soldout-arrow--next';
    nextBtn.setAttribute('aria-label', 'Próxima');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22"><path d="M9 6l6 6-6 6"/></svg>';

    container.appendChild(prevBtn);
    container.appendChild(nextBtn);

    function scrollByDir(dir){
      var firstCard = track.querySelector('.pdp-live__soldout-card');
      if (!firstCard) return;
      var cardWidth = firstCard.getBoundingClientRect().width;
      var gap = parseInt(getComputedStyle(track).gap || 14, 10);
      track.scrollBy({ left: dir * (cardWidth + gap) * 2, behavior: 'smooth' });
    }
    prevBtn.addEventListener('click', function(){ scrollByDir(-1); });
    nextBtn.addEventListener('click', function(){ scrollByDir(1); });

    function updateArrowState(){
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prevBtn.classList.toggle('is-disabled', atStart);
      nextBtn.classList.toggle('is-disabled', atEnd);
    }
    track.addEventListener('scroll', updateArrowState, { passive: true });
    setTimeout(updateArrowState, 100);
  }

  function loadRecommendations(container){
    var productHandle = container.getAttribute('data-product-handle') || '';
    var tagsStr = container.getAttribute('data-product-tags') || '';
    var currentTags = parseTags(tagsStr);
    var titleEl = container.parentNode.querySelector('[data-soldout-recommendations-title]');
    var dialog = container.closest('dialog');
    var sizeSel = dialog ? dialog.querySelector('[data-soldout-size-select]') : null;

    function hideSection(){ container.innerHTML = ''; if (titleEl) titleEl.style.display = 'none'; }
    if (!currentTags.length) { hideSection(); return; }

    getAllProducts()
      .then(function(products){
        var scored = [];
        products.forEach(function(p){
          if (p.handle === productHandle) return;
          if (EXCLUDED_HANDLES.indexOf(p.handle) >= 0) return;
          if (!isProductAvailable(p)) return;
          var score = scoreProduct(parseTags(p.tags), currentTags);
          if (score > 0) scored.push({ p: p, score: score });
        });
        scored.sort(function(a, b){ return b.score - a.score; });
        if (!scored.length) { hideSection(); return; }

        function render(){
          var targetSize = sizeSel ? (sizeSel.value || '').trim() : '';
          var matched = scored.filter(function(s){ return productHasSizeAvailable(s.p, targetSize); }).map(function(s){ return s.p; });
          var list, sizeMode;
          if (targetSize && matched.length) {
            list = matched.slice(0, MAX_RESULTS);
            sizeMode = true;
          } else {
            list = scored.map(function(s){ return s.p; }).slice(0, MAX_RESULTS);
            sizeMode = false;
          }
          if (!list.length) { hideSection(); return; }
          if (titleEl) {
            titleEl.style.display = '';
            titleEl.textContent = sizeMode ? ('Veja produtos similares no tamanho ' + targetSize) : 'Veja produtos similares';
          }
          renderSlider(container, list);
        }

        render();
        if (sizeSel && !sizeSel._recBound) {
          sizeSel._recBound = true;
          sizeSel.addEventListener('change', render);
        }
        if (dialog && 'MutationObserver' in window && !dialog._recObs) {
          dialog._recObs = true;
          new MutationObserver(function(){ if (dialog.hasAttribute('open')) render(); })
            .observe(dialog, { attributes: true, attributeFilter: ['open'] });
        }
      })
      .catch(function(err){ console.error('Recommendations erro:', err); hideSection(); });
  }

  /* ===== Identidade compartilhada ===== */
  function knownEmailVal(){
    if (window.AtipinaEmail && window.AtipinaEmail.get){
      var id = window.AtipinaEmail.get();
      if (id && id.email) return id.email;
    }
    return '';
  }
  function maskEmail(em){
    return (window.AtipinaEmail && window.AtipinaEmail.mask) ? window.AtipinaEmail.mask(em) : em;
  }

  function setupForm(form){
    if (form.__bisBound) return;
    form.__bisBound = true;

    var feedback = form.querySelector('[data-soldout-feedback]');
    var submitBtn = form.querySelector('button[type="submit"]');
    var emailEl = form.querySelector('[data-soldout-email]');
    var nameEl = form.querySelector('[data-soldout-name]');
    var knownBlock = form.querySelector('[data-soldout-known]');
    var knownEmailEl = form.querySelector('[data-soldout-known-email]');
    var notYouBtn = form.querySelector('[data-soldout-notyou]');
    var dialog = form.closest('dialog');

    var phoneInput = form.querySelector('[data-soldout-phone]');
    if (phoneInput){
      phoneInput.setAttribute('maxlength', '15');
      if (!phoneInput.placeholder || phoneInput.placeholder.toLowerCase().indexOf('celular') === 0){
        phoneInput.placeholder = '(11) 99999-9999';
      }
      bindPhoneMask(phoneInput);
    }

    function refreshKnown(){
      var em = knownEmailVal();
      if (em){
        if (emailEl){ emailEl.style.display = 'none'; emailEl.removeAttribute('required'); }
        if (knownBlock){ knownBlock.style.display = 'block'; if (knownEmailEl) knownEmailEl.textContent = maskEmail(em); }
      } else {
        if (emailEl){ emailEl.style.display = ''; emailEl.setAttribute('required',''); }
        if (knownBlock){ knownBlock.style.display = 'none'; }
      }
    }
    refreshKnown();
    if (notYouBtn) notYouBtn.addEventListener('click', function(){
      if (window.AtipinaEmail && window.AtipinaEmail.clear) window.AtipinaEmail.clear();
      refreshKnown();
      if (emailEl) setTimeout(function(){ emailEl.focus(); }, 60);
    });
    if (dialog && 'MutationObserver' in window){
      var mo = new MutationObserver(function(){ if (dialog.hasAttribute('open')) refreshKnown(); });
      mo.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();

      var companyId = form.getAttribute('data-klaviyo-company');
      var productTitle = form.getAttribute('data-product-title');
      var productHandle = form.getAttribute('data-product-handle');
      var productUrl = form.getAttribute('data-product-url');

      var consentEl = form.querySelector('[data-soldout-consent]');
      var sizeSel = form.querySelector('[data-soldout-size-select]');

      var email = knownEmailVal() || (emailEl.value || '').trim();
      var name = (nameEl.value || '').trim();
      var phoneRaw = (phoneInput.value || '').replace(/\D/g, '');
      var selectedOpt = sizeSel.options[sizeSel.selectedIndex];
      var size = sizeSel.value;
      var variantId = selectedOpt ? selectedOpt.getAttribute('data-variant-id') : '';

      feedback.textContent = '';
      feedback.classList.remove('is-error', 'is-success');

      if (!email || !name || !size || !variantId || !consentEl.checked) {
        feedback.textContent = 'Por favor, preencha os campos obrigatórios e autorize o recebimento.';
        feedback.classList.add('is-error');
        return;
      }

      var phoneFormatted = '';
      if (phoneRaw) {
        if (phoneRaw.length === 10 || phoneRaw.length === 11) {
          phoneFormatted = '+55' + phoneRaw;
        } else {
          feedback.textContent = 'Celular inválido. Use o formato (XX) XXXXX-XXXX.';
          feedback.classList.add('is-error');
          return;
        }
      }

      submitBtn.disabled = true;
      var origText = submitBtn.textContent;
      submitBtn.textContent = 'ENVIANDO…';

      var channels = ['EMAIL'];
      if (phoneFormatted) channels.push('SMS');

      var profileAttrs = {
        email: email,
        first_name: name,
        properties: {
          avise_me_produto: productTitle,
          avise_me_tamanho: size,
          avise_me_produto_handle: productHandle,
          avise_me_produto_url: productUrl,
          avise_me_data: new Date().toISOString()
        }
      };
      if (phoneFormatted) profileAttrs.phone_number = phoneFormatted;

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: channels,
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      })
        .then(function(resp){
          if (resp.status === 202 || resp.status === 200 || resp.status === 201) {
            if (window.AtipinaEmail && window.AtipinaEmail.set) window.AtipinaEmail.set(email);
            form.style.display = 'none';
            feedback.textContent = 'Pronto! Avisaremos você por e-mail assim que o tamanho ' + size + ' voltar ao estoque.';
            feedback.classList.add('is-success');
          } else {
            return resp.text().then(function(text){
              var detail = 'Erro ao enviar';
              try { var d = JSON.parse(text); if (d.errors && d.errors[0]) detail = d.errors[0].detail || detail; } catch(e){}
              throw new Error(detail);
            });
          }
        })
        .catch(function(err){
          console.error('Klaviyo BIS erro:', err);
          submitBtn.disabled = false;
          submitBtn.textContent = origText;
          feedback.textContent = 'Não foi possível enviar agora. Tente novamente em instantes.';
          feedback.classList.add('is-error');
        });
    });
  }

  function init(){
    document.querySelectorAll('[data-soldout-recommendations]').forEach(loadRecommendations);
    document.querySelectorAll('[data-soldout-form]').forEach(setupForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
